// 数据归类处理
export function groupDataByDate(data) {
  const seenDates = new Set()

  return data.map((item) => {
    const date = item.createTime.split(' ')[0] // 提取日期部分

    // 如果日期没有出现过，给当前项添加 time 字段
    if (!seenDates.has(date)) {
      seenDates.add(date)
      return { ...item, time: date }
    }

    // 日期已经出现过，直接返回原数据
    return item
  })
}
// 数据归类处理
export function groupDataByDate2(data) {
  const seenDates = new Set()

  return data.map((item) => {
    const date = item.redeemTime.split(' ')[0] // 提取日期部分

    // 如果日期没有出现过，给当前项添加 time 字段
    if (!seenDates.has(date)) {
      seenDates.add(date)
      return { ...item, time: date }
    }

    // 日期已经出现过，直接返回原数据
    return item
  })
}
